<template>
	<div class="card" style="min-height: 450px;">
        <h6 class="card-header text-primary" > Enroll State</h6>

        <div class="card-body px-3">
			Hello
			
		</div>
    </div>
</template>

<script>
export default {
	name: 'ListStateEnrolled',
	

}
</script>
